import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useState } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

import {
  useGetLocationsQuery,
  useDeleteLocationMutation,
} from "slices/common/locationSlice";
import { useSelector } from "react-redux";
import { hasActionAccess } from "utility";

function Locations() {
  const naviagte = useNavigate();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [del] = useDeleteLocationMutation();
  const auth = useSelector((state) => state.auth.auth?.user);

  const { data, isLoading, refetch } = useGetLocationsQuery({
    page,
    limit,
    search,
  });

  const col = [
    { display: "City Name", key: "cityName", type: "display" },
    { display: "Name", key: "full_name", type: "display" },
  ];

  const canEdit = hasActionAccess(auth, "Settings", "Locations", "edit");
  const canDelete = hasActionAccess(auth, "Settings", "Locations", "delete");

  if (canEdit || canDelete) {
    col.push({
      display: "Actions",
      key: "edit",
      type: "action",
      render: (row, onEdit, handleDelete) => (
        <>
          {canEdit && <Button onClick={() => onEdit(row)}>Edit</Button>}
          {canDelete && (
            <Button onClick={() => handleDelete(row._id)}>Delete</Button>
          )}
        </>
      ),
    });
  }

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };

  const changePage = (newPage, newLimit) => {
    const apiPage = newPage + 1; // MUI is 0-based, API is 1-based
    setPage(apiPage);
    setLimit(newLimit);
  };

  const onEdit = (row) => {
    naviagte(`/settings/locations/update-location/${row._id}`, {
      state: { refresh: true },
    });
  };

  const handleAdd = () => {
    naviagte("/settings/locations/add-location", { state: { refresh: true } });
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this location?")) {
      await del(id).unwrap();
      refetch();
    }
  };

  const canAdd = hasActionAccess(auth, "Settings", "Locations", "add");

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {canAdd && (
        <Button onClick={handleAdd} style={{ background: "#fff" }}>
          Add Location
        </Button>
      )}

      <Tables
        title={"Locations"}
        handleSearch={handleSearchChange}
        totalPages={data?.data?.pagination?.totalPages}
        data={data?.data?.data}
        columns={col}
        changePage={changePage}
        onEdit={onEdit}
        handleDelete={handleDelete}
        currentPage={page} // ✅ pass to control current pagination
        rowsPerPage={limit}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default Locations;
